import request from "@/utils/http"
import store from "@/store"
import { Message } from "element-ui"

export function create(data) {
  return request({
    url: "/sheet/printTemplate/create",
    method: "post",
    data
  }).commonDeal()
}

export function update(data) {
  return request({
    url: "/sheet/printTemplate/update",
    method: "post",
    data
  })
}

export function get(id) {
  return request({
    url: "/sheet/printTemplate/get/" + id,
    method: "get"
  })
}

export function remove(id) {
  return request({
    url: "/sheet/printTemplate/delete/" + id,
    method: "get"
  }).commonDeal()
}

export function getList({ type, id }) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  let url = "/sheet/printTemplate/list/"
  if (type == "appId") url = url + "appId/" + id
  else if (type == "sheetId") url = url + "sheetId/" + id
  return request({
    url,
    method: "get"
  }).commonDeal()
}

export function print({ dataId, templateId, appId } = {}) {
  return request.get(`/sheet/print`, { params: { dataId, templateId, appId } }).commonDeal()
}
